import { useState } from 'react';

import { VolatilitySufaceMarkingSidebar } from './volatility-suface-marking-sidebar';
import { VolatilitySufaceMarkingHeader } from './volatility-surface-marking-header';
import { VolatilitySurfaceMarkingTable } from './volatility-surface-marking-table';

import './styles.scss';

export const VolatilitySurfaceMarkingContent = () => {
  const [isVolatilitySufaceMarkingSidebarOpen, setIsVolatilitySufaceMarkingSidebarOpen] =
    useState(true);

  return (
    <div className="volatility-surface-marking-container">
      <div className="volatility-surface-marking-content">
        <div
          className={`volatility-surface-marking-menu 
          ${
            isVolatilitySufaceMarkingSidebarOpen
              ? 'volatility-surface-marking-menu-open'
              : 'volatility-surface-marking-menu-close'
          }
          `}
        >
          <VolatilitySufaceMarkingSidebar
            isVolatilitySufaceMarkingSidebarOpen={isVolatilitySufaceMarkingSidebarOpen}
            setIsVolatilitySufaceMarkingSidebarOpen={setIsVolatilitySufaceMarkingSidebarOpen}
          />
        </div>

        <div className="volatility-surface-marking-table">
          <VolatilitySufaceMarkingHeader />
          <VolatilitySurfaceMarkingTable />
        </div>
      </div>
    </div>
  );
};
